import { Component, Inject, Input, OnInit } from '@angular/core';
import { ProductService } from '../../product.service';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';

@Component({
	selector: 'app-product-rooms-edit',
	templateUrl: './product-rooms-edit.component.html',
	styleUrls: ['./product-rooms-edit.component.css'],
})
export class ProductRoomsEditComponent {
	@Input() editable: boolean;
	editor = ClassicEditor;
	subRooms: any[];
	conveniences: number[] = [];

	viewSet: Array<any> = [
		{ value: 'WM', name: 'Widok morze' },
		{ value: 'WG', name: 'Widok góry' },
		{ value: 'WMG', name: 'Widok morze i góry' },
		{ value: 'BW', name: 'Brak widoku' },
	];

	editorConfig = {
		toolbar: ['bold', 'italic', '|', 'bulletedList', 'numberedList'],
	};

	constructor(
		public service: ProductService,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialogRef: MatDialogRef<any>,
		private readonly infobox: InfoboxService,
	) {}

	addSubRoom() {
		this.data.roomSlaves.push({
			id: null,
			roomType: {
				id: null,
				name: null,
				code: null,
				configurations: [],
				kind: null,
			},
			fee: 0,
		});
	}

	getRoomType(subRoom) {
		subRoom.roomType = this.service.mockData.roomType.find(
			(findRoomType) => findRoomType.id === subRoom.roomType.id,
		);
	}

	getCodeName(roomId) {
		this.data.codeName = this.service.mockData.roomType.find((roomType) => roomType.id === roomId).code;
	}

	removeSubRoom(i: number) {
		this.data.roomSlaves.splice(i, 1);
	}

	editRoom() {
		this.infobox.warning('By zapisać konfigurację pokoi kliknij przycisk "zapisz i wyjdź"');
		this.dialogRef.close(this.data);
	}

	convertPriceToGrosze(price) {
		return price * 100;
	}
}
